import { CombinedCustomerInfo } from '../interfaces/Customer';
import { apiService } from '../../shared/services/apiService';

export const customerService = {
  async createCustomer(customerInfo: CombinedCustomerInfo) {
    const resp = await apiService.post<CombinedCustomerInfo>(
      'api/coach/customer',
      customerInfo,
    );

    return resp.data;
  },
  // use on customer setup flow by coach (after self registration)
  async setupCustomerProfile(customerId: number, customerInfo: CombinedCustomerInfo) {
    const resp = await apiService.put<CombinedCustomerInfo>(
      `api/coach/customer/${customerId}`,
      customerInfo,
    );

    return resp.data;
  },

  // TODO replace to auth module
  async sendSetPasswordLink(customerId: number) {
    const resp = await apiService.post<undefined>(
      `/api/user/${customerId}/set-password-link`,
    );

    return resp.data;
  },

  async getCustomerInfo(customerId: number): Promise<CombinedCustomerInfo> {
    const resp = await apiService.get<CombinedCustomerInfo>(
      `/api/customer/${customerId}`,
    );

    return resp.data;
  },

  async updateCustomerProfile(customerId: number, customerInfo: CombinedCustomerInfo) {
    const resp = await apiService.put<CombinedCustomerInfo>(
      `/api/customer/${customerId}`,
      customerInfo,
    );

    return resp.data;
  },
};
